module.exports = __webpack_public_path__ + "static/img/shuiji4.6f2db752.webp";